import { css } from '@emotion/css';

export const reviewCx = css`
  .agreement {
    padding: 1rem;
    .field-group {
      margin: 0 1rem;
      &:not(:last-of-type) {
        margin-bottom: 1rem;
      }
    }
  }
`;
